<div class="inner-page-wrapper flex w-full flex-col gap-24 bg-white pb-32 pt-24 lg:py-40">
    <h1 class="text-20 leading-25 lg:text-center lg:text-50 lg:leading-58">
        {{ numberOfVehicles() | number }} kurzfristig verfügbare Angebote
    </h1>
    <div class="flex w-full flex-wrap items-start justify-end gap-20 lg:ml-auto lg:w-max">
        <ui-input-select
            class="flex-1 md:w-[250px]"
            [options]="sortOptions() ?? []"
            [selected]="sortOptions()?.at(0)?.value ?? undefined"
            (selectedChange)="$event ? setSort($event) : removeSort()"
            placeholder="Empfehlung"
        />

        <button
            class="button-primary button-not-animated ml-auto w-max gap-8 lg:min-w-[125px]"
            (click)="openFilterDialog()"
        >
            <i class="icon-filter text-white"></i>

            <span>Filter</span>

            @if (countFilter()) {
                <span class="flex h-16 items-center bg-grey-100 px-8 text-12 text-black">
                    <span>{{ countFilter() }}</span>
                </span>
            }
        </button>
    </div>
</div>

@if (list().vehicles.length > 0) {
    <div class="lg:pt-80 bg-grey-100 py-24 lg:pb-40">
        <lib-vehicle-list [vehicles]="list().vehicles" />

        @defer {
            <div class="mt-24 lg:mt-32">
                <lib-pagination [allItemsCount]="numberOfVehicles()" />
            </div>
        }
    </div>
}

@defer {
    <div
        class="inner-page-wrapper flex flex-col gap-16 bg-white pb-64 pt-40 lg:flex-row lg:items-center lg:justify-between lg:py-40"
    >
        <div class="flex flex-col gap-12">
            <h5 class="leading-29 text-24">Kein passendes Angebot dabei ?</h5>
            <p class="text-16 leading-27">Wir beraten Sie gerne und bestellen Ihnen Ihr Wunschfahrzeug</p>
        </div>
        <div>
            <a class="button-secondary" [hyundaiRouterLink]="'https://www.hyundai.com/de/de/angebot-uebersicht.html'">
                Unsere Modelle
            </a>
        </div>
    </div>
}
